export class ColumnPage {
  init(): void {
    // コラム一覧ページ
  }
}
